import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestAddDeliveryZone } from "./addDeliveryZone.request";

const useAddDeliveryZone = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestAddDeliveryZone,
    ...options
  });
};

export default useAddDeliveryZone;
